<template>
  <div class="container">
      <main>
            <Search @getInputValue='getInputValue' @search='search' >锁机记录</Search>
            <el-table
                :data="list"
                header-align="center"
                :row-class-name="TableRowClassName"
                style="width:100%;padding:0 0px;height:100%"
                :header-cell-style="{ background: '#EBEEF8',height: '45px' }"
                :cell-style="{padding:'0px'}"
            >
            <el-table-column
            label="序号"
            type="index"
            :index="indexMethod"
            align="center"
            >
            </el-table-column>
            <el-table-column
            prop="factorNo"
            label="出厂编号"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="imei"
            label="IMEI"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="type"
            label="设备类型"
            align="center"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
                <span>{{scope.row.type==1?'塔机':'升降机'}}</span>
            </template>
            </el-table-column>
            <el-table-column
            prop="lockHandle"
            label="锁机操作"
            align="center"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
                <span :style="{color:scope.row.lockHandle==0?'#6D9E7B':'#AD454E'}">{{scope.row.lockHandle==0?'解锁操作':'锁机操作'}}</span>
            </template>
            </el-table-column>
            <el-table-column
            prop="creatTime"
            label="操作时间"
            align="center"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
                <span>{{scope.row.creatTime.replace(/T/,' ')}}</span>
            </template>
            </el-table-column>
            <el-table-column
            prop="creatUserName"
            label="操作人"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            </el-table>
            <Pagination :pageTotal="pageTotal" @currentPage="currentPage"/>
        </main>
  </div>
</template>

<script>
import '../assets/js/timeFomart'
export default {
    data(){
        return{
            option: {
                filter: '',
                pageSize: 15,
                pageIndex: 1
            },
            pageTotal: 1,
            list: [],
            inputValue: '',
        }
    },
    methods:{
        //获取list
        getList(option){
            this.$api.LockLogList(option).then(res=>{
                this.list = res.data.data.data;
                this.pageTotal = res.data.data.total;
            })
        },
        //获取页码
        currentPage(option){
            this.option.pageIndex = option
            this.getList(this.option);
        },
        //表格前编号
        indexMethod(index) {
            return index+1 ;
        },
        //表格隔行变色，样式在app.vue里
        TableRowClassName({row,rowIndex}){
            if(rowIndex%2 != 0){
                return 'backtablegray'
            }else{
                return 'backtablewhite'
            }
        },
        //获取搜索框值
        getInputValue(option){
            this.inputValue = option
        },
        //搜索按钮
        search(){
            this.getList({
                filter: this.inputValue,
                pageSize: 15,
                pageIndex: 1
            });
        },
    },
    mounted(){
        this.getList(this.option);
    }
}
</script>

<style lang='scss' scoped>
.container{
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
}
main{
    overflow: hidden;
    background: #fff;
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 0 8px;
}
</style>